import pickBy from 'lodash/pickBy';

type RemoveUndefined<T> = {
  [K in keyof T as undefined extends T[K] ? never : K]: T[K];
};

/**
 * Removes keys with `undefined` values from the given object (shallow).
 */
export default function removeUndefined<T extends Record<string, unknown>>(
  obj: T,
) {
  return pickBy(obj, value => value !== undefined) as RemoveUndefined<T>;
}
